import styled from "@emotion/styled";
import { NavbarLinkItemOptions } from "../NavbarV2Desktop";
import { Spacer } from "components/general/Spacer/Spacer";
import { Link } from "react-router-dom";
import { isInternalPath } from "utils/urlUtils";
import { css } from "@emotion/react";
import { Theme } from "styles/theme";

export const NavbarLinkItem = ({ icon, text, to }: NavbarLinkItemOptions) => {
  const Icon = icon;
  const isInternal = isInternalPath(to);
  const LinkItem = isInternal ? InternalLink : ExternalLink;
  const target = isInternal ? "_self" : "_blank";
  return (
    <LinkItem to={to} href={to} target={target}>
      <Icon />
      <Spacer width="8px" />
      {text}
    </LinkItem>
  );
};

// Sub-components

const linkStyle = (theme: Theme) => css`
  display: flex;
  color: ${theme.theme[1500]};
  font-size: ${theme.fontSize[5]};
  cursor: pointer;
  padding: 13px 10px;
  width: 100%;
  border-radius: 14px;

  &:hover {
    background-color: ${theme.button.tertiary.surface.default};
  }
`;

const InternalLink = styled(Link)`
  ${props => linkStyle(props.theme)}
`;

const ExternalLink = styled.a`
  ${props => linkStyle(props.theme)}
`;
